module.exports = __webpack_public_path__ + "img/air_liberty_footer.9c72257c.svg";